import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './bloco.action';
import * as laminaActions from '../lamina/lamina.action';
import * as commonActions from '@common/common.action';
import BlocoPage from './bloco.page';
import WebapiCommon from '@common/util/webapi.common';
import BlocoApi from './bloco.api';
import { getUsuarioLocalStorage } from '../../../../../localStorage.util';
import { acessoPermitido } from '../../../../../acessos.seguranca';

class BlocoContainer extends Component {
  constructor(props) {
    super(props);
    this.usuario = getUsuarioLocalStorage();
    this.state = {
      laudoIsValido: false,
      frascos: [],
      frasco: null,
      numeroBlocos: 1,
      variosFragmentos: false,
      numeroFragmentos: 1,
      novoscortes: false,
      coloracao: false,
      antigeno: false,
      coloracoes: [],
      coloracaoSelecionada: null,
      antigenoSelecionado: null,
      antigenos: [],
      materiais: [],
      material: null,
      tipos: [],
      tipo: {
        label: 'Congelacao',
        value: 'Congelacao',
      },
      sentinelaMelanoma: false,
      sentinelaMama: false,
      medicoTecnico: [],
      tecnico: null,
      medicoCongelacao: [],
      medico: null,
      anotacoes: '',
      listarBlocos: [],
      activeTab: '1',
      nrExame: null,
      showModalJustificativa: false,
      justificativa: '',
      procedimentoId: 0,
      tipoId: 0,
      exameId: 0,
    };
  }

  onChangeNrExame = (nrExame) =>
    this.setState({ nrExame, laudoIsValido: false });

  onChangeFrasco = (frasco) => this.setState({ frasco });
  onChangeNumeroBlocos = (numeroBlocos) => this.setState({ numeroBlocos });
  onChangeNumeroFragmentos = (numeroFragmentos) =>
    this.setState({ numeroFragmentos });
  onChangeVariosFragmentos = (variosFragmentos) =>
    this.setState({ variosFragmentos });
  onChangeCheckNovosCortes = (novoscortes) => this.setState({ novoscortes });
  onChangeCheckColoracao = (coloracao) => this.setState({ coloracao });
  onChangeCheckAntigeno = (antigeno) => this.setState({ antigeno });
  onChangeSelecaoColoracao = (coloracaoSelecionada) => {
    this.setState({ coloracaoSelecionada });
  };
  onChangeSelecaoAntigeno = (antigenoSelecionado) =>
    this.setState({ antigenoSelecionado });
  onChangeSelecaoMaterial = (material) => this.setState({ material });
  onChangeTecnico = (tecnico) => this.setState({ tecnico });
  onChangeMedico = (medico) => this.setState({ medico });
  onChangeAnocacoes = (anotacoes) => this.setState({ anotacoes });

  pesquisarValidadeNExame(nrExame) {
    this.props.commonActions.showFadeCarregando(true);
    let medicoPadrao = this.props.medicoPadrao;

    WebapiCommon.laudoExiteEMaterialFoiFinalizado(encodeURIComponent(nrExame))
      .then((res) => {
        this.setState({ laudo: res.laudo, laudoIsValido: true });
        Promise.all([
          WebapiCommon.getFrascos(res.laudo),
          WebapiCommon.getMaterial(),
          WebapiCommon.getMedicos(),
          WebapiCommon.obterUsuarios(),
          WebapiCommon.getColoracoes(),
          WebapiCommon.getAntigenos(),
        ]).then((resArray) => {
          let medico = this.state.medico;
          if (medicoPadrao !== null) {
            let encontrouMedico = resArray[2].find(
              (el) => el.value === medicoPadrao
            );
            if (encontrouMedico) {
              medico = encontrouMedico;
            }
          }

          this.setState({
            frascos: resArray[0]
              .filter((el) => el.status !== 'CANCELADO')
              .map((frasco) => ({
                value: frasco.frascoId,
                label: frasco.dsFrasco,
              })),
            materiais: resArray[1],
            medicoCongelacao: resArray[2],
            medico,
            medicoTecnico: resArray[3],
            tecnico: {
              label: this.usuario.usuarioId + ' - ' + this.usuario.usuario,
              value: this.usuario.usuarioId,
            },
            coloracoes: resArray[4][1].options,
            antigenos: resArray[5],
          });

          this.props.commonActions.showFadeCarregando(false);
        });
      })
      .catch(() => this.setState({ laudoIsValido: false }));
  }

  adicionarBloco() {
    const laudo = this.props.laudo;

    const {
      frasco,
      numeroBlocos,
      numeroFragmentos,
      material,
      tipo,
      medico,
      tecnico,
      novoscortes,
      variosFragmentos,
      anotacoes,
      sentinelaMama,
      sentinelaMelanoma,
      coloracao,
      coloracaoSelecionada,
      antigeno,
      antigenoSelecionado,
    } = this.state;

    if (
      frasco === null ||
      frasco.length === 0 ||
      material === null ||
      medico === null ||
      tecnico === null
    ) {
      this.props.commonActions.showAlerta(
        'erro',
        'Preencha todos os campos',
        1500
      );
    } else {
      let blocos = [
        {
          frascoId: frasco.map((f) => f.value),
          cassetes: numeroBlocos,
          fragmentos: numeroFragmentos,
          materialId: material.value,
          novosCortes: novoscortes,
        },
      ];
      this.props.commonActions.showFadeCarregando(true);
      WebapiCommon.gerarBlocos(laudo, blocos).then((blocoResponse) => {
        this.props.commonActions.showFadeCarregando(false);
        const mapaCongelacao = {
          frascoId: frasco.map((f) => f.value),
          materialId: material.value,
          medicoId: medico.value,
          tecnicoId: tecnico.value,
          tipoBloco: tipo.label,
          anotacao: anotacoes,
          sentinelaMama: sentinelaMama,
          sentinelaMelanoma: sentinelaMelanoma,
          novosCortes: novoscortes,
          coloracao: coloracao,
          coloracoesId: coloracao ? coloracaoSelecionada.map((c) => c.id) : [],
          antigeno: antigeno,
          antigenosId: antigeno ? antigenoSelecionado.map((a) => a.value) : [],
          blocos: blocoResponse.map((bloco) => ({
            bloco: bloco.bloco,
            numeroBloco: bloco.numeroBloco,
            fragmentos: variosFragmentos ? 0 : numeroFragmentos,
            nuOrdem: bloco.nuOrdem,
          })),
        };

        WebapiCommon.gravarBlocos(laudo, mapaCongelacao)
          .then((result) => {
            this.props.commonActions.showFadeCarregando(false);
            if (result.success) {
              let message = 'Bloco criado com sucesso.';
              let size = message.length * 10 + 'px';
              this.props.commonActions.showAlerta(
                'sucesso',
                message,
                5000,
                size
              );
              this.props.actions.modalBloco(!this.props.modalBloco);
              this.props.laminaActions.modalLamina(!this.props.modalLamina);
            }
          })
          .catch((err) => {
            this.props.commonActions.showAlerta('erro', err.message, 1500);
          });
      });
    }
  }

  limparCampos = () => {
    this.setState({
      frascos: [],
      frasco: null,
      numeroBlocos: 1,
      variosFragmentos: false,
      numeroFragmentos: 1,
      novoscortes: false,
      coloracao: false,
      antigeno: false,
      coloracaoSelecionada: null,
      antigenoSelecionado: null,
      material: null,
      sentinelaMelanoma: false,
      sentinelaMama: false,
      tecnico: null,
      medico: null,
      anotacoes: '',
    });

    this.props.actions.alterarBlocoText('Adicionar Bloco');
    this.props.actions.atualizablocoID(null);
  };

  onChangeTab = (activeTab) => this.setState({ activeTab });

  componentDidMount() {
    if (this.props.nrExame && this.props.nrExame !== this.state.nrExame) {
      this.setState({ nrExame: this.props.nrExame });
      return this.pesquisarValidadeNExame(this.props.nrExame);
    }
  }

  // Justificativa
  apagarBlocoJustificativa(id) {
    const existeLamina = this.props.listarLaminas.findIndex(
      (lamina) => lamina.idBloco === id
    );
    if (existeLamina >= 0) {
      this.props.actions.modalConfirmar(true);
    } else {
      this.setState({
        showModalJustificativa: true,
        idLaudoBloco: id,
      });
    }
  }

  toggleModalJustificativa() {
    this.setState({
      showModalJustificativa: !this.state.showModalJustificativa,
      idLaudoBloco: null,
    });
  }

  setJustificativa(texto) {
    this.setState({
      justificativa: texto,
    });
  }

  toggle = (activeTab) => this.setState({ activeTab });

  updateValorSentinela(name) {
    this.setState((state) => ({
      sentinelaMama: name === 'sentinelaMama' && !state.sentinelaMama,
      sentinelaMelanoma:
        name === 'sentinelaMelanoma' && !state.sentinelaMelanoma,
    }));
  }

  // Editar

  editarBlocoId() {
    const blocoId = this.props.blocoId;
    const coloracoesId = !this.state.coloracaoSelecionada
      ? []
      : this.state.coloracaoSelecionada.map((cor) => cor.id)[0];

    const antigenosId = !this.state.antigenoSelecionado
      ? []
      : !this.state.antigenoSelecionado.length
      ? this.state.antigenoSelecionado.value
      : this.state.antigenoSelecionado.map((ant) => ant.value);

    const payload = {
      usuarioLogado: this.props.usuario.usuarioId,
      usuarioNome: this.props.usuario.usuario,
      nrExame: this.props.nrExame,
      cdMaterial: !this.state.material ? 0 : this.state.material.value,
      tipoBloco: 'congelacao',
      observacao: this.state.anotacoes,
      cdMedico: !this.state.medico ? 0 : this.state.medico.value,
      idTecnico: !this.state.tecnico ? 0 : this.state.tecnico.value,
      sentinelaMama: this.state.sentinelaMama,
      sentinelaMelanoma: this.state.sentinelaMelanoma,
      coloracao: this.state.coloracao,
      coloracoesId,
      antigeno: this.state.antigeno,
      antigenosId: !antigenosId ? [] : antigenosId,
      procedimentoId: this.state.procedimentoId,
      tipoId: this.state.tipoId,
      exameId: this.state.exameId,
    };

    const state = { ...this.state };

    //atualizar a listagem de blocos
    this.props.commonActions.showFadeCarregando(true);
    BlocoApi.editarBlocoCongelacao(this.state.laudo, blocoId, payload).then(
      (res) => {
        this.props.commonActions.showFadeCarregando(false);
        this.props.commonActions.showAlerta(
          'sucesso',
          res.message,
          2000,
          res.message.length * 10 + 'px'
        );
        this.pesquisarBlocoAtualizar(state, blocoId);
        this.limparCampos();
        this.toggle('2');
      }
    );
  }

  editarBloco(id) {
    const existeLamina = this.props.listarLaminas.findIndex(
      (lamina) => lamina.idBloco === id
    );
    if (existeLamina >= 0) {
      this.props.actions.modalConfirmar(true);
    } else {
      const laudo = this.props.laudo;
      const antigenos = this.state.antigenos;
      const coloracoes = this.state.coloracoes;

      BlocoApi.getListarDetalhesBloco(laudo, id).then((bloco) => {
        const antigenoSelecionado = antigenos.find(
          (antigeno) => antigeno.value === bloco.antigenosId[0]
        );

        const listaColoracao = [];
        const coloracaoSelecionado = bloco.coloracoesId.map((id, i) => {
          coloracoes.find(
            (color) => color.id === id && listaColoracao.push(color)
          );
          return listaColoracao;
        });
        this.setState({
          frascos: bloco.frascos,
          frasco: bloco.frasco,
          numeroBlocos: bloco.numeroBlocos,
          variosFragmentos: bloco.variosFragmentos,
          numeroFragmentos: bloco.numeroFragmentos,
          novoscortes: bloco.novoscortes,
          coloracao: bloco.coloracao,
          antigeno: bloco.antigeno,
          coloracaoSelecionada: coloracaoSelecionado[0],
          antigenoSelecionado: antigenoSelecionado,
          material: {
            label: `${bloco.materialId} - ${bloco.nmMaterial}`,
            value: bloco.materialId,
          },
          sentinelaMelanoma: bloco.sentinelaMelanoma,
          sentinelaMama: bloco.sentinelaMama,
          tecnico: {
            label: `${bloco.tecnicoId} - ${bloco.tecnico}`,
            value: bloco.tecnicoId,
          },
          medico: {
            label: `${bloco.medicoId} - ${bloco.medico}`,
            value: bloco.medicoId,
          },
          anotacoes: bloco.anotacoes,
          procedimentoId: bloco.procedimentoId,
          tipoId: bloco.tipoId,
          exameId: bloco.exameId,
        });

        this.props.actions.alterarBlocoText('Editar Bloco');
        this.props.actions.atualizablocoID(id);
        this.toggle('1');
      });
    }
  }

  pesquisarBlocoAtualizar(dados, id) {
    const novaLista = this.props.listarBlocos.map((bloco) => {
      if (bloco.idLaudoBloco === id) {
        bloco.nomeMedico = dados.medico.label.split('-')[1].trim();
      }
      return bloco;
    });
    novaLista && this.props.actions.atualizarListagemBlocos(novaLista);
  }

  removerBlocoLista = () => {
    const id = this.state.idLaudoBloco;
    const justificativa = this.state.justificativa;
    if (justificativa && id) {
      const blocos = this.props.listarBlocos;
      const laudo = this.props.laudo;
      const lista = [];

      if (id && laudo && blocos) {
        blocos.map((bloco) => {
          if (bloco.idLaudoBloco !== id) {
            lista.push(bloco);
          }
          return lista;
        });
        this.props.commonActions.showFadeCarregando(true);
        BlocoApi.apagarBlocoCongelacao(laudo, id, justificativa).then((res) => {
          this.props.commonActions.showFadeCarregando(false);
          if (res.success) {
            this.props.commonActions.showAlerta(
              'sucesso',
              res.message,
              2000,
              res.message.length * 10 + 'px'
            );
            this.props.actions.atualizarListagemBlocos(lista);
          }
        });
        this.setState({ showModalJustificativa: false, justificativa: '' });
      }
    }
  };

  render() {
    return (
      <BlocoPage
        usuario={this.props.usuario}
        acessoPermitido={acessoPermitido}
        activeTab={this.state.activeTab}
        listarBlocos={this.props.listarBlocos}
        nrExame={this.state.nrExame}
        updateValorSentinela={this.updateValorSentinela.bind(this)}
        onChangeTab={this.onChangeTab.bind(this)}
        onChangeNrExame={this.onChangeNrExame.bind(this)}
        onChangeFrasco={this.onChangeFrasco.bind(this)}
        onChangeNumeroBlocos={this.onChangeNumeroBlocos.bind(this)}
        onChangeNumeroFragmentos={this.onChangeNumeroFragmentos.bind(this)}
        onChangeVariosFragmentos={this.onChangeVariosFragmentos.bind(this)}
        onChangeCheckNovosCortes={this.onChangeCheckNovosCortes.bind(this)}
        onChangeCheckColoracao={this.onChangeCheckColoracao.bind(this)}
        onChangeCheckAntigeno={this.onChangeCheckAntigeno.bind(this)}
        onChangeSelecaoColoracao={this.onChangeSelecaoColoracao.bind(this)}
        onChangeSelecaoAntigeno={this.onChangeSelecaoAntigeno.bind(this)}
        onChangeSelecaoMaterial={this.onChangeSelecaoMaterial.bind(this)}
        onChangeTecnico={this.onChangeTecnico.bind(this)}
        onChangeMedico={this.onChangeMedico.bind(this)}
        onChangeAnocacoes={this.onChangeAnocacoes.bind(this)}
        pesquisarValidadeNExame={this.pesquisarValidadeNExame.bind(this)}
        adicionarBloco={this.adicionarBloco.bind(this)}
        editarBlocoId={this.editarBlocoId.bind(this)}
        laudoIsValido={this.state.laudoIsValido}
        frascos={this.state.frascos}
        frasco={this.state.frasco}
        numeroBlocos={this.state.numeroBlocos}
        variosFragmentos={this.state.variosFragmentos}
        numeroFragmentos={this.state.numeroFragmentos}
        novoscortes={this.state.novoscortes}
        coloracao={this.state.coloracao}
        antigeno={this.state.antigeno}
        coloracoes={this.state.coloracoes}
        coloracaoSelecionada={this.state.coloracaoSelecionada}
        antigenoSelecionado={this.state.antigenoSelecionado}
        antigenos={this.state.antigenos}
        materiais={this.state.materiais}
        material={this.state.material}
        tipos={this.state.tipos}
        tipo={this.state.tipo}
        sentinelaMelanoma={this.state.sentinelaMelanoma}
        sentinelaMama={this.state.sentinelaMama}
        medicoTecnico={this.state.medicoTecnico}
        tecnico={this.state.tecnico}
        medicoCongelacao={this.state.medicoCongelacao}
        medico={this.state.medico}
        anotacoes={this.state.anotacoes}
        limparCampos={this.limparCampos.bind(this)}
        showModalJustificativa={this.state.showModalJustificativa}
        justificativa={this.state.justificativa}
        setJustificativa={this.setJustificativa.bind(this)}
        toggleModalJustificativa={this.toggleModalJustificativa.bind(this)}
        apagarBlocoJustificativa={this.apagarBlocoJustificativa.bind(this)}
        removerBlocoLista={this.removerBlocoLista.bind(this)}
        editarBloco={this.editarBloco.bind(this)}
        blocoText={this.props.blocoText}
        blocoId={this.props.blocoId}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    usuario: state.usuario,
    modalBloco: state.blocoCongelacao.modalBloco,
    modalConfirmar: state.blocoCongelacao.modalConfirmar,
    modalLamina: state.laminaCongelacao.modalLamina,
    carregarLaminas: state.laminaCongelacao.carregarLaminas,
    carregarBlocos: state.blocoCongelacao.carregarBlocos,
    listarBlocos: state.blocoCongelacao.listarBlocos,
    listarLaminas: state.laminaCongelacao.listarLaminas,
    blocoText: state.blocoCongelacao.blocoText,
    blocoId: state.blocoCongelacao.blocoId,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators(actions, dispatch),
    laminaActions: bindActionCreators(laminaActions, dispatch),
    commonActions: bindActionCreators(commonActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BlocoContainer);



// WEBPACK FOOTER //
// ./src/app/common/requisicaoCongelacao/tabs/bloco/bloco.container.js